import React from "react";
import HelloText from "../components/HelloText";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { Button } from "@mui/material";
const Medical = () => {
  const { data, error } = useSWR(process.env.REACT_APP_DEF_URL + "medical");
  if (error) return <div>failed to load</div>;
  if (!data)
    return (
      <div>
        <HelloText />
        <Link to={"/medicaladd"}>
          <Button
            variant="outlined"
            sx={{
              marginLeft: "40px",
              marginBottom: "20px",
            }}
          >
            Ekle
          </Button>
        </Link>
        <p style={{ marginLeft: "40px", marginBottom: "20px" }}>Türkçe</p>
      </div>
    );
  return (
    <div>
      <HelloText />
      <Link to={"/medical/add"}>
        <Button
          variant="outlined"
          sx={{
            marginLeft: "40px",
            marginBottom: "20px",
          }}
        >
          Ekle
        </Button>
      </Link>
      <p style={{ marginLeft: "40px", marginBottom: "20px" }}>Türkçe</p>
      <div className="home-list">
        {data.map((data) => (
          <Link to={"/medical/update/" + data.medical_link}>
            <div className="home-list-item">
              <div className="home-list-image">
                <img src={data.medical_image} alt={data.medical_title} />
              </div>
              <div className="home-list-body">
                <p>{data.medical_title}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Medical;
